<script lang="ts">
	import type { TeaserContent } from '../../../domain/teaser/TeaserContent.ts';
	import { onMount } from 'svelte';
	import { getHeadlineUpdates } from '../../../services/teaser/HeadlineHelper.ts';
	import { TeaserType } from '../../../domain/teaser/TeaserType.ts';
	import TrackingService from '../../../services/tracking/TrackingService.ts';
	import { onViewport } from '../../../services/tracking/IntersectionObserver';
	import { trackClick, trackSeen, trackView } from '../../../services/tracking/TeaserTracking.ts';
	import { toNewProgramStructureSignUpSheet, toSignUpSheet } from '../../../domain/SheetData.ts';
	import { TeaserTouchPoint } from '../../../domain/teaser/TeaserUtils.ts';

	let { teaserContent, teaserType, teaserSize, teaserTouchPoint, newProgramStructureDesign }: {
		teaserContent: TeaserContent,
		teaserType: TeaserType,
		teaserSize: string,
		teaserTouchPoint: TeaserTouchPoint | undefined,
		newProgramStructureDesign: boolean
	} = $props();

	const teaserContainerMargin = teaserContent.isProductList ? 'margin-in-product-list' : 'oc-mx-100';

	let headline = $state(teaserContent.heading);

	let teaser: Element;
	let trackingService: TrackingService;
	const signUpSheetData: string = getSheetData();
	function getSheetData() {
		if (newProgramStructureDesign) {
			return JSON.stringify(toNewProgramStructureSignUpSheet(teaserType, teaserContent, teaserTouchPoint));
		} else {
			return JSON.stringify(toSignUpSheet(teaserType, teaserContent, teaserTouchPoint))
		}
	}

	onMount(() => {
		trackingService = new TrackingService();
		watchForHeadlineUpdates();
		trackClick(trackingService, teaser, teaserContent, teaserType, teaserSize);
		trackView(trackingService, teaser, teaserContent, teaserType, teaserSize);
	});

	const watchForHeadlineUpdates = () => {
		const intervalId = window.setInterval(() => {
			if (teaserContent.countdown) {
				headline = getHeadlineUpdates(teaserContent.countdown, teaserContent.heading, teaserType, intervalId);
			}
		}, 1000);
	};
</script>

<div class="oc-mt-100 oc-mb-150 {teaserContainerMargin}"
	id="teaser-container"
	data-testid="up-teaser-l-container"
	data-oc-sheet-v1-create={signUpSheetData}
	bind:this={teaser}
	use:onViewport
	onenterViewport={() => trackSeen(trackingService)}>
	<oc-media-object-card-v1
		as-button=""
		inverted="true"
		data-testid="to-signup-teaser-card"
		elevation-level="canvas"
		icon="otto-up"
		size="100"
		variant="icon"
		oc-aria-label="Anmeldung zum Vorteilsprogramm"
	>
		<div aria-hidden="true" id="headline" slot="headline">{headline}</div>
		<div aria-hidden="true" id="subline" slot="subline">{teaserContent?.subheading}</div>
	</oc-media-object-card-v1>

</div>
